<template>
    <div class="data_body">
        <!--  v-if="this.ooption.xdata.length" -->
        <div style="width: 100%; height: 100%">
            <div id="charts_canvas" class="echart" style="width: 100%; height: 100%; "></div>
        </div>
        <!-- <div style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;"
            v-show="!this.ooption.xdata.length">暂无数据</div> -->
    </div>
</template>
  
<script>
export default {
    props: {
        evCourseArray: {
            type: Array,
            default: []
        },
        eva: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                xdata: [],
                sdata: [],
            },
            option: {
                tooltip: {
                    trigger: 'item'
                },
                // legend: {
                // },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 24630, name: '文学类' },
                            { value: 6948, name: '其他类' },
                            { value: 2996, name: '语言文字类' },
                            { value: 2828, name: '文化科学教育体育类' },
                            { value: 1701, name: '历史地理类' },
                            { value: 1288, name: '生物科学类' },
                            { value: 1243, name: '艺术类' },
                            { value: 507, name: '综合性图书' },
                            { value: 475, name: '数理科学和化学' },
                            { value: 436, name: '天文学地球科学' },
                            { value: 301, name: '工业技术' },
                            { value: 210, name: '哲学宗教' },
                            { value: 193, name: '医药卫生' },
                            { value: 129, name: '农业科学' },
                            { value: 124, name: '自然科学总论' },
                            { value: 80, name: '政治法律' },
                            { value: 69, name: '环境科学安全科学' },
                            { value: 66, name: '马克思主义' },
                            { value: 57, name: '军事' },
                            { value: 52, name: '航空航天' },
                            { value: 51, name: '交通运输' },
                            { value: 44, name: '社会科学总论' },
                            { value: 31, name: '经济' },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            },
        };
    },
    methods: {
        setChart(option) {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = this.$echarts.init(
                    //劳动课程
                    this.$el.querySelector("#charts_canvas")
                );
                // this.option.radar.indicator = option.xdata;
                // this.option.series[0].data[0].value = option.sdata;
                // 初始化雷达图
                this.chartObj = chartObj;
                this.chartObj.setOption(this.option);
            });
        },
        setArray(array) {
            this.ooption = {
                xdata: [],
                sdata: [],
            }
            for (var i = 0; i < array.length; i++) {
                if (array[i].evid == this.eva) {
                    this.ooption.xdata = array[i].indicator
                    this.ooption.sdata = array[i].value
                    break;
                }
            }
            setTimeout(() => {
                // if (!this.chartObj) {
                this.setChart(this.ooption);
                // } else {
                //     this.option.radar.indicator = this.ooption.xdata;
                //     this.option.series[0].data[0].value = this.ooption.sdata;
                //     this.chartObj.setOption(this.option);
                // }
            }, 100);
            this.$forceUpdate();
        },
    },
    watch: {
        evCourseArray: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.setArray(newValue)
                this.$forceUpdate();
            },
        },
        eva: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.setArray(this.evCourseArray)
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        this.setArray(this.evCourseArray)
        // this.setChart(this.ooption);
        var _this = this;
        window.addEventListener("resize", () => {
            if (_this.chartObj) {
                _this.chartObj.resize();
            }
        });
    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    /* display: flex; */
    position: relative;
    border-radius: 5px;
    /* border: 1px solid #eee; */
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    background: #fff;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/dataBoardSies/library/studentInfo/index.vue